@if (isEditing) {
  <app-grants-form
    *ngIf="isEditing"
    [isEditMode]="true"
    [grantId]="grant.id"
    (formSubmitted)="onFormUpdated($event)">
  </app-grants-form>
} @else {
  <div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12" *ngIf="grantExists;else notLoaded">
    <div class="custom-card-large">
      <div class="card-body d-flex row justify-content-center text-center">
        <div>
          <div class="d-flex justify-content-end">
            <button *ngIf="!grant?.isDeleted && !isDeleting"
                    class="btn btn-primary delete-btn"
                    (click)="deleteGrant()"
                    style="padding-bottom: 3px;">
              <span class="material-symbols-outlined">
                delete
              </span>
            </button>

            <button *ngIf="grant?.isDeleted && (teacher?.role?.toLowerCase() === 'admin')"
                    class="btn btn-primary delete-btn"
                    (click)="undeleteGrant()">
              Undelete
            </button>
          </div>
        </div>
        <div *ngIf="grantExists">
          <div *ngIf="grant; else noGrant">

            <h5 class="title mb-3">Grant Information</h5>
            <div class="row row-cols-4 mb-3">
              <div class="col txt">
                Grant Status:
              </div>
              <div class="col">
                {{ grant.status }}
              </div>
              <div class="col txt">
                Grant Application Open:
              </div>
              <div class="col">
                {{ grant.applicationOpenDate }}
              </div>

              <div class="col txt">Grant Name:</div>
              <div class="col">{{ grant.name }}</div>
              <div class="col txt">Grant Application End:</div>
              <div class="col">{{ grant.applicationCloseDate }}</div>
              <div class="col txt">Grant Web Link:</div>
              <div class="col">
                <a [href]="grant.webLink" target="_blank" rel="noopener">
                  {{ grant.webLink }}
                </a>
              </div>
              <div class="col txt">Grant Contact Name:</div>
              <div class="col">{{ grant.contactName }}</div>
              <div class="col txt">Grant Contact Phone Number:</div>
              <div class="col">{{ formatPhone(grant.contactPhone) }}</div>
              <div class="col txt">Grant Amount (up to) :</div>
              <div class="col">$ {{ grant.amount }}</div>
            </div>

            <h5 class="title mb-3">Details</h5>
            <div class="row row-cols-2 mb-3">
              <div class="col txt">Grant Description:</div>
              <div class="col txt">Grant Commentary:</div>

              <div class="col">{{ grant.description }}</div>
              <div class="col">{{ grant.commentary }}</div>
            </div>

            <h5 class="title mb-3">More Information</h5>
            <div class="row row-cols-4">
              <div class="col txt">Created By:</div>
              <div class="col">{{ grant.createdBy }}</div>

              <div class="col txt">Updated By:</div>
              <div class="col">{{ grant.updatedBy }}</div>

              <div class="col txt">Created Date:</div>
              <div class="col">{{ grant.creationDate | date:'short' }}</div>

              <div class="col txt">Updated Date:</div>
              <div class="col">{{ grant.updatedDate | date:'short' }}</div>
            </div>

            <br/>

            <div class="mt-4">
              <div class="d-flex justify-content-center gap-3 flex-column flex-md-row">
                <a routerLink="/grants" class="btn btn-primary w-25">Return To List View</a>
                <button class="btn btn-primary w-25" (click)="toggleEditing()" *ngIf="teacher?.role !== 'Teacher'">Edit</button>
              </div>
            </div>

          </div>
        </div>

        <ng-template #noGrant>
          <h4>Loading Grant Details...</h4>
        </ng-template>
      </div>
    </div>
  </div>
}

<ng-template #notLoaded>
  <div class="container mt-5 pt-5 col-lg-10 col-me-10 col-12 text-center">
    <div class="custom-card-large">
      <h2>You do not have access to this page.</h2>
    </div>
  </div>
</ng-template>
